import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import CTABanner from "../components/CTABanner";
import { PRODUCTS } from "../data/products";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import Seo, { buildBreadcrumb } from "../components/Seo";
import { PAGE_SEO } from "../data/seo";
import PicImg from "../components/PicImg";

export default function ProductsList() {
  const seo = PAGE_SEO.productsList;
  const itemListSchema = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    itemListElement: PRODUCTS.map((p, i) => ({
      "@type": "ListItem",
      position: i + 1,
      url: `https://www.liftile.com/products/${p.slug}`,
      name: p.name,
    })),
  };
  return (
    <>
      <Seo
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        path={seo.path}
        image={seo.image}
        jsonLd={[
          buildBreadcrumb([
            { name: "Home", path: "/" },
            { name: "Products", path: "/products" },
          ]),
          itemListSchema,
        ]}
        jsonLdId="products"
      />
      <Navbar />
      <section className="pt-32 pb-12 bg-liftile-black">
        <div className="container-x">
          <div className="heading-eyebrow mb-3">Our Catalog</div>
          <h1 className="display-1 text-liftile-cream max-w-4xl">
            Complete <span className="text-liftile-orange">Construction</span><br />Lifting Solutions
          </h1>
          <p className="font-body text-liftile-cream/65 max-w-2xl mt-5">
            Premium machinery built for safety, durability and high productivity. Explore our complete range of construction lifting equipment.
          </p>
        </div>
      </section>

      <section className="bg-liftile-cream py-16 md:py-20">
        <div className="container-x grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {PRODUCTS.map((p, i) => (
            <motion.div
              key={p.slug}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.05 }}
            >
              <Link
                to={`/products/${p.slug}`}
                data-testid={`products-list-${p.slug}`}
                className="group block bg-white border border-liftile-mid-gray/10 hover:border-liftile-orange hover:-translate-y-1 transition-all"
              >
                <div className="aspect-[4/3] overflow-hidden bg-liftile-cream-light">
                  <PicImg src={p.image} alt={p.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" loading="lazy" decoding="async" />
                </div>
                <div className="p-6">
                  <div className="font-heading text-xs uppercase tracking-wider text-liftile-orange mb-2">{p.category}</div>
                  <h3 className="font-heading text-lg uppercase tracking-wider font-semibold text-liftile-matte-black">{p.name}</h3>
                  <p className="text-sm text-liftile-mid-gray/70 mt-2">{p.short_description}</p>
                  <div className="mt-5 inline-flex items-center gap-2 font-heading text-xs uppercase tracking-wider text-liftile-orange">
                    View Details <ArrowRight className="w-3 h-3 group-hover:translate-x-1 transition-transform" />
                  </div>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </section>
      <CTABanner
        headline="Need the Right Machine for Your Project?"
        description="Our engineering team is ready to help you choose the ideal solution for your construction requirements."
      />
      <Footer />
    </>
  );
}
